// extracted by mini-css-extract-plugin
module.exports = {"container":"purify_annualFee__container--2Z6by","annualFee":"purify_annualFee__annualFee--2mUwm","annualFeeDisclaimer":"purify_annualFee__annualFeeDisclaimer--U212V"};